import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "../../interface/api/IRestServiceOptions";
import IRestServiceCollectionResponse from "../../interface/api/IRestServiceCollectionResponse";
import IPopup from "../../interface/dataStorage/IPopup";

export interface IRestPopupServiceCollectionResponse extends IRestServiceCollectionResponse {
    results: Array<IPopup>
}

interface IRestPopupService {
    collectionList(options?: IRestServiceOptions): Promise<IRestPopupServiceCollectionResponse>,
    collectionCreate(data: any): Promise<IPopup>,
    resourceRetrieve(id: number|string): Promise<IPopup>,
    resourceCheckRetrieve(id: number|string): Promise<IPopup>,
    resourceUpdate(id: number|string, data: any): Promise<IPopup>,
    resourceDelete(id: number|string): Promise<void>,
}

const COLLECTION = 'popups'

const PopupService: IRestPopupService = {
    collectionList: function (options?) {
        return RestService.collectionList(COLLECTION, options as unknown as IRestServiceOptions) as Promise<IRestPopupServiceCollectionResponse>
    },
    collectionCreate: function ( data) {
        return RestService.collectionCreate(COLLECTION, data) as Promise<IPopup>
    },
    resourceRetrieve: function (id) {
        return RestService.resourceRetrieve(COLLECTION, id) as Promise<IPopup>
    },
    resourceCheckRetrieve: function (id) {
        return RestService.resourceRetrieve(COLLECTION + '-check', id, {_no_error_messages: true}) as Promise<IPopup>
    },
    resourceDelete: function (id) {
        return RestService.resourceDelete(COLLECTION, id)
    },
    resourceUpdate: function (id, data) {
        return RestService.resourceUpdate(COLLECTION, id, data) as Promise<IPopup>
    }
}

export default PopupService